import { render } from "./Experience.vue?vue&type=template&id=08099579&scoped=true&ts=true"
import script from "./Experience.vue?vue&type=script&lang=ts"
export * from "./Experience.vue?vue&type=script&lang=ts"

import "@/components/Experience/style.scss?vue&type=style&index=0&id=08099579&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08099579"]])

export default __exports__